<template>
  <div class="companyDynamics">
    <mt-navbar v-model="selected">
      <mt-tab-item id="1" >新闻动态</mt-tab-item>
      <mt-tab-item id="2">行业研究</mt-tab-item>
    </mt-navbar>

    <!-- tab-container -->
    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="1">
        <mt-cell v-for="(item,index) in newsList" :key="index">
          <!--<router-link :to={name:'news.detail',params:{id:item.id}}></router-link>  跳转详情页面-->
            <router-link :to="{name:'companyDetail',query:{'id':item.articleId} }">
              <div class="newslist">
                <h5 class="title">{{item.title}}</h5>
                <p class="time">{{item.relaseDate}}</p>
                <div class="newscontent">
                  <img :src="'http://citgroup.cn'+item.images" alt="">
                  <p class="con-descript" style="-webkit-box-orient: vertical;">
                    {{item.description}}
                  </p>
                </div>
              </div>
            </router-link>
        </mt-cell>
         <!--加载更多按钮-->
        <div class="loadMore">
           <span class="moreSpan" v-if="show" @click="moreNewsList()">加载更多</span>
            <span v-else="show">已加载全部</span>
        </div>
      </mt-tab-container-item>
      <mt-tab-container-item id="2">
        <mt-cell v-for="(item,index) in industryList" :key="index">
          <router-link :to="{name:'companyDetail',query:{id:item.articleId} }">
            <div class="newslist">
              <h5 class="title">{{item.title}}</h5>
              <p class="time">{{item.relaseDate}}</p>
              <div class="newscontent">
                <img :src="'http://citgroup.cn'+item.images" alt="">
                <p class="con-descript" style="-webkit-box-orient: vertical;">
                  {{item.description}}
                  </p>
              </div>
            </div>
          </router-link>
        </mt-cell>
        <!--加载更多按钮-->
        <div class="loadMore">
          <span class="moreSpan" v-if="showindustry" @click="moreIndustryList()">加载更多</span>
          <span v-else="showindustry">已加载全部</span>
        </div>
      </mt-tab-container-item>
    </mt-tab-container>

  </div>
</template>

<script>
  import config from '../../assets/js/config.js'
export default {
  name: 'companyDynamics',
  data () {
    return {
      msg: '',
      selected:'1',
      newsList:[],
      industryList:[],
      show:true,
      showindustry:true,
      newsnumber:2,
      industrynumber:2
    }
  },
  mounted(){
      this.getNewsList();
      this.getIndustryList();
  },
  methods:{
      getNewsList(){
        var that=this;
        that.$ajax.post(config.companyPage.newsList,JSON.stringify({"columnId":379,"page":1}))
          .then(function (response){
//              console.log(JSON.parse(response))
            console.log(response.data)
              that.newsList= response.data.data.article;
            console.log(response.data.data.article)
          })
      },
    getIndustryList(){
        var that=this;
        that.$ajax.post(config.companyPage.industryList,JSON.stringify({"columnId":378,"page":1,"size":10}))
          .then(function (response){
  //              console.log(JSON.parse(response))
            console.log(response.data)
            that.industryList= response.data.data.article;
            console.log(response.data.data.article)
          })
      },
    moreNewsList(){
      var that=this;
      that.$ajax.post(config.companyPage.newsList,JSON.stringify({"columnId":379,"page":that.newsnumber}))
        .then(function (response){
//            console.log(response.data.data.num)
          let number=Math.ceil(response.data.data.num/10);
          if(response.data.data.article.length>0){

            that.newsnumber++;
                if(that.newsnumber-1 >= number) {
                  that.show = false;
                }
          }
          that.newsList=that.newsList.concat(response.data.data.article);
        })
    },
    moreIndustryList(){
      var that=this;
      that.$ajax.post(config.companyPage.industryList,JSON.stringify({"columnId":378,"page":that.industrynumber}))
        .then(function (response){
//            console.log(response.data.data.num)
          let number2=Math.ceil(response.data.data.num/10);
          if(response.data.data.article.length>0){

            that.industrynumber++;
            if(that.industrynumber-1 >= number2) {
              that.showindustry = false;
            }
          }
          that.industryList=that.industryList.concat(response.data.data.article);
        })
    }
  }
}
</script>

<style scoped>
  .companyDynamics{
    margin-bottom: 1rem;
    /*font-family: "Microsoft YaHei";*/
  }
  .companyDynamics .mint-navbar{
    border-bottom: 1px solid #ddd;
    height: 0.64rem;

  }
  .companyDynamics .mint-tab-item {
    font-size: 0.24rem!important;
  }
  .companyDynamics .mint-cell{
    padding: 0.2rem 0.15rem;
  }
  .newslist h5{
    text-align: left;
    font-size: 0.24rem;
    font-weight: 700;
    margin: 0;
    color: #333;
    line-height: 0.4rem;
  }
  .newslist p.time{
    text-align: left;
    line-height: 0.5rem;
    font-size: 0.22rem;
    color: #777;
    margin-bottom:0.08rem;
  }
  .newscontent{
    height: 2rem;
    border-bottom: 1px solid #ddd;
  }
.newscontent img{
  width: 30%;
  float: left;
  height: 1.6rem;
}
  .newscontent p.con-descript{
    width: 65%;
    float: left;
    color: #777;
    margin-left:0.2rem;
    text-align: left;
    line-height: 0.4rem;
    font-size: 0.22rem;
    text-indent: 2em;
    word-break: break-all;
    overflow : hidden;  /** 隐藏超出的内容 **/
    text-overflow: ellipsis;
    display: -webkit-box;  /** 对象作为伸缩盒子模型显示 **/
    -webkit-line-clamp: 4;   /** 显示的行数 **/
    -webkit-box-orient: vertical;  /** 设置或检索伸缩盒对象的子元素的排列方式 **/

  }
  .loadMore{
    padding: 0.2rem 0 1.6rem;
    font-size: 0.24rem;
  }
  .moreSpan{
    display: block;
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/companyDynamics/companyDynamics.vue